import axios from 'axios';

/** A publikus API régi webcímre 404 + {"redirect": "<új slug>"} választ ad — ezt olvassuk ki. */
export const redirectSlugFrom = (error: unknown): string | null => {
  if (!axios.isAxiosError(error) || error.response?.status !== 404) return null;
  const data: unknown = error.response.data;
  if (typeof data !== 'object' || data === null || !('redirect' in data)) return null;
  const value = (data as { redirect?: unknown }).redirect;
  return typeof value === 'string' && value !== '' ? value : null;
};
